import type { SbBlokData } from "@storyblok/react/rsc";
import { storyblokEditable } from "@storyblok/react/rsc";
import clsx from "clsx";

import { Heading, Subtitle } from "@/components/atoms";

import { HeroStoryblokCustom } from "@/types/globals";
import StoryblokComponent from "../StoryblokComponent/StoryblokComponent";
import StoryblokLink from "../StoryblokLink";
import styles from "./hero.module.css";

export const HeroUI = ({
  blok,
  length,
}: {
  blok: HeroStoryblokCustom;
  length: number;
}) => {
  const { media, preamble, title, button, darkText, inset, backgroundOpacity } =
    blok;

  const fontColor = darkText
    ? { color: "black" }
    : { color: "var(--color-base)" };
  const imageBlok = media?.[0];

  return (
    <div
      {...storyblokEditable(blok as unknown as SbBlokData)}
      className={clsx(styles.outerwrapper, inset && styles.inset, "hero")}
    >
      <div
        style={{
          background: `rgba(0, 0, 0, ${(backgroundOpacity?.value ?? 0) / 100})`,
          height: "100%",
          width: "100%",
          position: "absolute",
          top: 0,
          left: 0,
          zIndex: 1,
        }}
      ></div>
      {imageBlok && <StoryblokComponent blok={imageBlok} />}
      <div
        className={styles.wrapper}
        style={{
          color: darkText ? "black" : "var(--color-base)",
          zIndex: 2,
        }}
      >
        {preamble && preamble.length > 0 && (
          <Subtitle style={fontColor}>{preamble}</Subtitle>
        )}
        {title && (
          <div className="hero-title">
            <Heading
              as={"h2"}
              styledAs={length === 2 ? "h2" : "h1"}
              className={styles.heading}
              style={fontColor}
            >
              {title}
            </Heading>
          </div>
        )}
        {button?.[0] && (
          <StoryblokLink
            blok={{ link: button?.[0].link, text: button?.[0].text }}
            darkText={darkText}
          />
        )}
      </div>
    </div>
  );
};
